<!-- Figma 7767:9139 — inline registro detail. No prices and no total for any
     seller: the expanded row lists products only. -->
<div
  class="order-detail-card relative mb-6 flex flex-col rounded-2xl border-neutral-200 bg-neutral-50 p-6"
  *ngIf="order; else loadingOrderDetailCard"
>
  <div class="mb-6 flex flex-row items-center justify-between">
    <div class="flex flex-col gap-1">
      <ui-paragraph
        class="order-detail-card__meta"
        type="p12"
        mobile-type="p12"
        font-weight="semibold"
        text-color="neutral-400"
        content="N° Registro: {{ order.orderNumber }} | {{ district }}"
      />
      <ui-paragraph
        type="p20"
        mobile-type="p20"
        font-weight="bold"
        text-color="neutral-700"
        [content]="alias || order.companyName"
      />
      <ui-paragraph
        *ngIf="alias"
        type="p14"
        mobile-type="p14"
        font-weight="regular"
        text-color="neutral-700"
        [content]="order.companyName"
      />
    </div>
    <div class="w-[100px]">
      <ui-button
        class="order-detail-card__view-more w-full"
        type="primary"
        responsive="false"
        font-weight="medium"
        button-text="Ver más"
        icon-suffix="eye-on"
        [customSizeConfig]="viewMoreSizeConfig"
        (clicked)="goDetail()"
      ></ui-button>
    </div>
  </div>

  <table class="table-detail-card mb-6">
    <thead>
      <tr>
        <th *ngFor="let head of productHeads; index as i">
          <div
            class="mb-4 border-b-neutrals-400 pb-4"
            [class.text-center]="i > 1"
          >
            <!-- The kit's headline is a block with its own `text-align: left`,
                 so Cantidad / UM center on the headline itself, over their
                 centered values (Figma 7767:9139). -->
            <ui-headline
              class="order-detail-card__head"
              [ngClass]="{ '!text-center': i > 1 }"
              type="h12"
              mobile-type="h12"
              font-weight="semibold"
              text-color="neutral-400"
              [content]="head"
            />
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of order.saleOrderItems">
        <td class="pb-1 pt-1">
          <ui-paragraph
            type="p14"
            mobile-type="p14"
            font-weight="regular"
            text-color="neutral-700"
            [content]="item.sku"
          />
        </td>
        <td class="pb-1 pt-1">
          <ui-paragraph
            type="p14"
            mobile-type="p14"
            font-weight="regular"
            text-color="neutral-700"
            [content]="item.productName"
          />
        </td>
        <td class="pb-1 pt-1 text-center">
          <ui-paragraph
            type="p14"
            mobile-type="p14"
            font-weight="regular"
            text-color="neutral-700"
            [content]="item.quantity"
          />
        </td>
        <td class="pb-1 pt-1 text-center">
          <ui-paragraph
            type="p14"
            mobile-type="p14"
            font-weight="regular"
            text-color="neutral-700"
            [content]="getMeasurementUnit(item)"
          />
        </td>
      </tr>
    </tbody>
  </table>

  <ng-container *ngTemplateOutlet="collapseButton"></ng-container>
</div>

<!-- Figma 7767:9139 — "Ocultar" pill centered on the card's bottom edge. -->
<ng-template #collapseButton>
  <div class="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2">
    <button
      type="button"
      class="order-detail-card__collapse flex items-center gap-1 rounded-full bg-primary-100 px-4 py-1"
      (click)="collapse()"
    >
      <ui-paragraph
        type="p10"
        mobile-type="p10"
        font-weight="bold"
        text-color="primary-600"
        content="Ocultar"
      />
      <ui-icon
        name="chevron-up"
        size="16"
        mobile-size="16"
        fill="primary-600"
      ></ui-icon>
    </button>
  </div>
</ng-template>

<ng-template #loadingOrderDetailCard>
  <div
    class="relative mb-6 flex flex-col rounded-2xl border-neutral-200 bg-neutral-50 p-6"
  >
    <div class="mb-6 flex h-10 flex-row items-center justify-between">
      <div class="h-full w-[200px]">
        <ngx-skeleton-loader
          class="h-full w-full"
          appearance="circle"
          count="1"
          [theme]="{
            width: '100%',
            height: '100%',
            borderRadius: '0.5rem',
            margin: '0',
          }"
        />
      </div>
      <div class="h-full w-[130px]">
        <ngx-skeleton-loader
          class="h-full w-full"
          appearance="circle"
          count="1"
          [theme]="{
            width: '100%',
            height: '100%',
            borderRadius: '0.5rem',
            margin: '0',
          }"
        />
      </div>
    </div>

    <table class="table-detail-card mb-6">
      <thead>
        <tr>
          <th *ngFor="let head of productHeads">
            <div class="mb-4 border-b-neutrals-400 pb-4">
              <div class="w-[80px]">
                <ngx-skeleton-loader />
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of [0, 1, 3]">
          <td class="pb-1 pt-1">
            <div class="w-[110px]">
              <ngx-skeleton-loader />
            </div>
          </td>
          <td class="pb-1 pt-1">
            <div class="md:w-[200px] lg:w-[400px]">
              <ngx-skeleton-loader />
            </div>
          </td>
          <td class="pb-1 pt-1">
            <div class="w-[80px]">
              <ngx-skeleton-loader />
            </div>
          </td>
          <td class="pb-1 pt-1">
            <div class="w-[80px]">
              <ngx-skeleton-loader />
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <ng-container *ngTemplateOutlet="collapseButton"></ng-container>
  </div>
</ng-template>
